import React from 'react';
import { createPortal } from 'react-dom';

function SafetyMatrixModal({ show, onClose, categories, causes, processes, isCheckedInMatrix, useProcess = true }) {
  if (!show) return null;

  return createPortal(
    <div style={{
      position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(15,23,42,0.45)', backdropFilter: 'blur(4px)',
      zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center'
    }} onClick={onClose}>
      <div style={{ width: '96%', maxWidth: 1500, maxHeight: '82vh', background: '#fff', borderRadius: 16, overflow: 'hidden', display: 'flex', flexDirection: 'column' }} onClick={e => e.stopPropagation()}>
        <div style={{ padding: '16px 24px', background: '#1e3a8a', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0 }}>
          <h5 style={{ color: '#fff', fontWeight: 800, margin: 0 }}><i className="bi bi-grid-3x3 me-2"></i>표준 유해·위험요인 매트릭스 조감도</h5>
          <button onClick={onClose} style={{ background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.3)', color: '#fff', fontSize: '0.8rem', fontWeight: 700, padding: '6px 16px', borderRadius: 8, cursor: 'pointer' }}>
            <i className="bi bi-x-lg me-1"></i>닫기
          </button>
        </div>
        <div style={{ flex: '1 1 auto', overflow: 'auto', padding: '16px' }}>
          <table className="sf-table table-bordered text-center align-middle" style={{ width: '100%', minWidth: '1400px', margin: 0, tableLayout: 'fixed', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                {useProcess && (
                  <th rowSpan={2} style={{
                    width: '180px', position: 'sticky', left: 0, zIndex: 12, background: '#f1f5f9',
                    borderRight: '2px solid #cbd5e1', padding: 0, height: '60px'
                  }}>
                    <div style={{ position: 'relative', width: '100%', height: '100%', minHeight: 60 }}>
                      <div style={{
                        position: 'absolute', top: 0, left: 0, width: '100%', height: '100%',
                        background: 'linear-gradient(to right bottom, transparent calc(50% - 0.5px), #cbd5e1 calc(50% - 0.5px), #cbd5e1 calc(50% + 0.5px), transparent calc(50% + 0.5px))'
                      }}></div>
                      <span style={{ position: 'absolute', top: 4, right: 6, fontSize: '0.9rem', fontWeight: 800, color: '#b91c1c' }}>유해위험분류</span>
                      <span style={{ position: 'absolute', bottom: 4, left: 6, fontSize: '0.9rem', fontWeight: 800, color: '#1e40af' }}>평가 공정</span>
                    </div>
                  </th>
                )}
                {categories.map(cat => {
                  const catCauses = causes.filter(c => c.categoryId === cat.id);
                  if (catCauses.length === 0) return null;
                  return <th key={cat.id} colSpan={catCauses.length} style={{ padding: '8px 4px', wordBreak: 'keep-all', color: cat.color, fontSize: '0.82rem', fontWeight: 800, borderBottom: `3px solid ${cat.color}`, background: `${cat.color}08` }}>{cat.name}</th>;
                })}
              </tr>
              <tr>
                {categories.map(cat => {
                  const catCauses = causes.filter(c => c.categoryId === cat.id);
                  return catCauses.map(cause => (
                    <th key={cause.id} style={{ width: '38px', padding: '6px 2px', height: '240px', verticalAlign: 'bottom', background: '#fff', borderBottom: '2px solid #e2e8f0' }}>
                      <div style={{ writingMode: 'vertical-rl', textAlign: 'left', fontSize: '0.72rem', letterSpacing: '0.5px', lineHeight: '2.2', maxHeight: '220px', margin: '0 auto', color: '#475569', fontWeight: 500 }}>
                        {cause.name}
                      </div>
                    </th>
                  ));
                })}
              </tr>
            </thead>
            <tbody>
              {useProcess && processes.map((proc) => (
                <tr key={proc.id} style={{ borderBottom: '1px solid #e2e8f0' }}>
                  <td style={{ position: 'sticky', left: 0, zIndex: 9, background: '#fff', textAlign: 'left', borderRight: '2px solid #cbd5e1', fontWeight: 700, fontSize: '0.78rem', padding: '10px 12px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '180px' }}>{proc.name}</td>
                  {categories.map(cat => {
                    const catCauses = causes.filter(c => c.categoryId === cat.id);
                    return catCauses.map(cause => {
                      const checked = isCheckedInMatrix(proc.id, cause.id);
                      return (
                        <td key={cause.id} style={{ padding: '4px', background: checked ? `${cat.color}06` : '#fff' }}>
                          {checked && (
                            <div style={{
                              width: 18, height: 18, borderRadius: '50%',
                              background: cat.color, color: '#fff',
                              display: 'flex', alignItems: 'center', justifyContent: 'center',
                              margin: '0 auto', fontSize: '0.65rem', fontWeight: 'bold',
                              boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                            }}>
                              ✓
                            </div>
                          )}
                        </td>
                      );
                    });
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>,
    document.body
  );
}

export default SafetyMatrixModal;
